import React from 'react'
import { NavLink } from 'react-router-dom'

class Header extends React.Component {

  state = {
    isActive: false,
  }

  toggleNav = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }))
  }

  render() {
    return (
      <nav className="navbar is-transparent"
          aria-label="main navigation">
        <div className="navbar-brand">
          <NavLink className="navbar-item" to="/" activeClassName="is-active">
            <img src={window.location.origin + "/assets/img/icon-left-font-monochrome-white.svg"} alt="Park Park Go: find parking spots nearby" width="112" height="28"/>
          </NavLink>
          <button className="button navbar-burger is-transparent" onClick={this.toggleNav}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div className={ this.state.isActive ? 'navbar-menu is-active' : 'navbar-menu'}>
          <div className="navbar-end">
            <NavLink
              className="navbar-item"
              to="/login"
              activeClassName="is-active">
              <span className="icon has-text-primary" style={{ marginRight: 5 }}>
                <i className="fa-inverse fas fa-sign-in-alt"></i>
              </span>
              Login
            </NavLink>
          </div>
        </div>
      </nav>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js